const messages: Record<string, string> = {
  otp_expired: "That link has expired or was already used. Request a new one below.",
  access_denied: "Sign-in was cancelled.",
};

/**
 * Supabase reports failed email links and OAuth hand-backs in the URL, in
 * the hash or the query string. Returns a sentence to show, or null when the
 * URL carries no auth error.
 */
export const authErrorFromUrl = (url: { hash: string; search: string }) => {
  const read = (raw: string) => new URLSearchParams(raw.replace(/^[#?]/, ""));
  const params = [read(url.hash), read(url.search)];
  const pick = (key: string) => params.map((p) => p.get(key)).find(Boolean) ?? null;
  if (!pick("error") && !pick("error_code")) return null;
  const code = pick("error_code");
  const error = pick("error");
  return (
    (code && messages[code]) ||
    (error && messages[error]) ||
    "That link didn’t work. Try again, or request a new one below."
  );
};
